import React from 'react';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import { COLOR_BLACK_HAZE, COLOR_CARNATION, COLOR_DENIM, COLOR_REGENT_ST_BLUE } from 'popTheme';

export const PopInputField = ({ iconDataTestId, onClickClearButton, ...props }) => {
  return (
    <TextField
      {...props}
      sx={{
        input: {
          color: COLOR_DENIM,
          fontSize: '1rem',
        },
        bgcolor: COLOR_BLACK_HAZE,
        borderRadius: '0.375rem',
        borderColor: COLOR_REGENT_ST_BLUE,
        mt: '0.5rem',
      }}
      InputProps={{
        endAdornment: (
          <IconButton
            edge="end"
            size="small"
            onClick={onClickClearButton}
            data-testid={iconDataTestId}
            sx={{
              visibility: props.error && !props?.hidebutton ? 'visible' : 'hidden',
              bgcolor: COLOR_BLACK_HAZE,
              color: COLOR_CARNATION,
              ':hover': {
                bgcolor: COLOR_BLACK_HAZE,
              },
            }}
          >
            <CancelIcon sx={{ fontSize: 'medium' }} />
          </IconButton>
        ),
      }}
    />
  );
};
